/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ venueName: NonNullable<unknown> }} Placefollowflyertagline3Inputs */

const en_placefollowflyertagline3 = /** @type {(inputs: Placefollowflyertagline3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scan the code and never miss a thing at ${i?.venueName}: events, offers and what's on today.`)
};

const de_placefollowflyertagline3 = /** @type {(inputs: Placefollowflyertagline3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scan den Code und verpass nichts mehr von ${i?.venueName}: Events, Aktionen und was heute los ist.`)
};

/**
* | output |
* | --- |
* | "Scan the code and never miss a thing at {venueName}: events, offers and what's on today." |
*
* @param {Placefollowflyertagline3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placefollowflyertagline3 = /** @type {((inputs: Placefollowflyertagline3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placefollowflyertagline3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placefollowflyertagline3(inputs)
	return de_placefollowflyertagline3(inputs)
});
export { placefollowflyertagline3 as "placeFollowFlyerTagline" }